import { registerBeginnerActiveBuzzerBlocks } from './active-buzzer-blocks.js';
import { registerBeginnerMicrophoneBlocks } from './microphone-blocks.js';
import { registerBeginnerPassiveBuzzerBlocks } from './passive-buzzer-blocks.js';
import { registerBeginnerSpeakerBlocks } from './speaker-blocks.js';

let registered = false;

export function registerBeginnerSoundBlocks(): void {
  if (registered) {
    return;
  }
  registerBeginnerActiveBuzzerBlocks();
  registerBeginnerPassiveBuzzerBlocks();
  registerBeginnerSpeakerBlocks();
  registerBeginnerMicrophoneBlocks();
  registered = true;
}
